import { useCallback } from "react";

const writeHeight = (
    target: HTMLElement,
    name: string,
    entries: readonly ResizeObserverEntry[],
) =>
    entries.forEach(({ borderBoxSize: [size] }) => {
        if (size !== undefined) {
            target.style.setProperty(name, `${size.blockSize}px`);
        }
    });

/**
 * A ref callback that keeps the observed element's border-box height in
 * the custom property `name` on `target`, for offsets under sticky rows.
 * Elements of one kind share a height, so any of them can be observed.
 */
export const useHeightProperty = (target: HTMLElement | null, name: string) =>
    useCallback(
        (node: HTMLElement | null) => {
            if (node === null || target === null) {
                return undefined;
            }
            const observer = new ResizeObserver((entries) =>
                writeHeight(target, name, entries),
            );
            observer.observe(node);
            return () => observer.disconnect();
        },
        [target, name],
    );
